import { render } from "./journeyHeader.vue?vue&type=template&id=51033120&scoped=true&lang=true"
import script from "./journeyHeader.vue?vue&type=script&lang=js"
export * from "./journeyHeader.vue?vue&type=script&lang=js"

import "./journeyHeader.vue?vue&type=style&index=0&id=51033120&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51033120"]])

export default __exports__